import { getQueryParam } from './getQueryParam';

export const getXDomainHeader = (customSearchQuery?: string) => {
  const queryParamDomain = getQueryParam('domain', customSearchQuery);
  const queryParamBroker = getQueryParam('broker', customSearchQuery);
  const user = sessionStorage.getItem('user');
  const userRole = user ? JSON.parse(user)?.role?.name : null;

  if (['manager', 'admin'].includes(userRole) && queryParamDomain && queryParamBroker) {

    return JSON.stringify({
      'props': { 'tenant': 'poland', 'agency': queryParamBroker, 'branch' : queryParamDomain },
      'meta': { 'tenant': 'poland', 'agency': queryParamBroker, 'branch' : queryParamDomain }
    });

  }
};
